import React from "react";
import "./Headings.css";

export default class Heading1 extends React.Component {
  public render() {
    return <h1 className="heading1">{this.props.children}</h1>;
  }
}
